module.exports = __webpack_public_path__ + "static/media/userexperience.c4a28ec2.png";